import { api } from "@/api/client";
import type { AgentChatResponse } from "@/api/types";

export interface AgentChatPayload {
  session_id?: string;
  message: string;
}

export interface AgentQuickPayload {
  message?: string;
  folder_id?: string;
  file_id?: string;
}

export const sendAgentMessage = (payload: AgentChatPayload) =>
  api.post<AgentChatResponse>("/v1/agent/chat", payload);

export const approveAgentPlan = (sessionId: string) =>
  api.post<AgentChatResponse>(`/v1/agent/chat/${sessionId}/approve`);

export const cancelAgentPlan = (sessionId: string) =>
  api.post<AgentChatResponse>(`/v1/agent/chat/${sessionId}/cancel`);

export const getAgentStatus = (sessionId: string) =>
  api.get<AgentChatResponse>(`/v1/agent/chat/${sessionId}/status`);

export const organizeWithAgent = (payload: AgentQuickPayload) =>
  api.post<AgentChatResponse>("/v1/agent/organize", payload);

export const summarizeFolderWithAgent = (payload: AgentQuickPayload) =>
  api.post<AgentChatResponse>("/v1/agent/summarize", payload);

export const smartFindWithAgent = (payload: AgentQuickPayload) =>
  api.post<AgentChatResponse>("/v1/agent/find", payload);

export const cleanupWithAgent = (payload: AgentQuickPayload) =>
  api.post<AgentChatResponse>("/v1/agent/cleanup", payload);

export const describeWithAgent = (payload: AgentQuickPayload) =>
  api.post<AgentChatResponse>("/v1/agent/describe", payload);
